import React, { useState, useEffect } from 'react';
import {
  array
} from 'prop-types';
import { dynamicRecsDataModel } from '../dataModel';
import { DynamicRecsWrapper } from '../dynamic-recs/DynamicRecsWrapper';
import { useRecommendationFlags } from '../hooks/useRecommendationFlags';

const RecsFilterItemIdsWrapper = (props) => {

  const { cartItemsData } = props;
  const sliceItemsArrayCount = 2; // FS changes in near future
  const initialDateInNanoSeconds = 122192928000000000; // nanoseconds of Jan 01, 1970
  const [finalArr, setFinalArr] = useState(null);
  const [itemsData, setItemsData] = useState(null);
  const [newAnchorId, setNewAnchorId] = useState('');

  useEffect(() => {
    if (cartItemsData?.length) {
      setItemsData(cartItemsData);
    }
  }, [cartItemsData]);

  const { loading, data: productData, error } = useRecommendationFlags(newAnchorId);

  const collectionsFlag = productData !== undefined
    ? productData?.product?.info?.recommendationFlags?.collections : null;

  const getTime = (uuid) => {
    let uuidArr = uuid.split('-'); // split - from uuid string
    let timeStr = [
      uuidArr[2].substring(1), // third arr val last three chars
      uuidArr[1], // second arr val
      uuidArr[0] // first arr val
    ].join('');
    return parseInt(timeStr, 16); // convert the high bits from hex to decimal
  };

  const getDateVal = (uuID, itemId) => {
    let timeVal = getTime(uuID) - initialDateInNanoSeconds; // to get item added date
    let millisecTime = Math.floor(timeVal / 10000);
    return Math.floor(new Date(millisecTime).getTime() / 1000) + '-' + itemId;
  };

  const getItemIds = (firstArray, secondArray) => {
    let filterArr = [];
    for (let firstArrIndex = 0; firstArrIndex < firstArray.length; firstArrIndex += 1) {
      for (let secArrIndex = 0; secArrIndex < secondArray.length; secArrIndex += 1) {
        if (firstArray[firstArrIndex] === (secondArray[secArrIndex].split('-')[0])) {
          filterArr.push(secondArray[secArrIndex].split('-')[1]);
        }
      }
    }
    return filterArr;
  };

  useEffect(() => {
    let newItemIds = [];
    if (itemsData?.length > 1) {
      let getCartItems = [];
      getCartItems = itemsData?.map((val) => {
        let splitVal = val.split('_');
        return getDateVal(splitVal[0], splitVal[1]);
      });

      let newItems = [];
      [...getCartItems].map((item) => {
        return newItems.push(item.split('-')[0]);
      });
      const filterNewItems = newItems.sort((prevVal, currVal) => currVal - prevVal);
      newItemIds = getItemIds(filterNewItems.slice(0, sliceItemsArrayCount), getCartItems);
      setFinalArr(newItemIds);
      setNewAnchorId(newItemIds[0]);
    }
    if (itemsData?.length === 1) {
      setFinalArr([itemsData[0].split('_')[1]]);
      setNewAnchorId(itemsData[0].split('_')[1]);
    }
  }, [itemsData]);

  if (error && !loading) {
    return null;
  }

  if (!loading && !(collectionsFlag)) {
    let index = finalArr?.length && finalArr?.indexOf(newAnchorId);
    if (index >= 0 && index < finalArr.length - 1) {
      setNewAnchorId(finalArr[index + 1]);
    }
  }

  if (!loading && collectionsFlag) {
    return (
    /* eslint-disable react/jsx-props-no-spreading */
      <DynamicRecsWrapper {...props} anchorId={newAnchorId} />
    );
  }
  return null;
};
RecsFilterItemIdsWrapper.displayName = 'RecsFilterItemIdsWrapper';

const propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  cartItemsData: array
};
const defaultProps = {
  cartItemsData: null
};
const dataModel = dynamicRecsDataModel;

RecsFilterItemIdsWrapper.propTypes = propTypes;
RecsFilterItemIdsWrapper.defaultProps = defaultProps;
RecsFilterItemIdsWrapper.dataModel = dataModel;

export default RecsFilterItemIdsWrapper;